function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWashingMachineColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2B1B7"
    },
    points: "472.615,101.275 416.352,78.769 438.857,473.419 472.615,444.484 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4D3D9"
    },
    points: "39.385,101.275 39.385,512 393.846,512 438.857,473.419 438.857,78.769 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#748993"
    },
    points: "438.857,444.484 416.352,478.242 438.857,512 472.615,512 472.615,444.484 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.846,
    y: 444.484,
    style: {
      fill: "#A2B1B7"
    },
    width: 45.011,
    height: 67.516
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#57676E"
    },
    points: "438.857,0 416.352,50.637 438.857,101.275 472.615,101.275 472.615,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#748993"
    },
    points: "174.418,0 151.912,50.637 174.418,101.275 438.857,101.275 438.857,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2B1B7"
    },
    points: "39.385,101.275 174.418,101.275 174.418,33.758 106.901,22.505 39.385,33.758 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.385,
    style: {
      fill: "#C4D3D9"
    },
    width: 135.033,
    height: 33.758
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57676E"
    },
    d: "M337.193,317.89v-90.022h49.128c-18.657-54.027-69.954-92.835-130.321-92.835 c-76.13,0-137.846,61.716-137.846,137.846S179.87,410.725,256,410.725c60.368,0,111.664-38.808,130.321-92.835H337.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEE6FF"
    },
    d: "M256,180.044v185.67c51.271,0,92.835-41.564,92.835-92.835S307.271,180.044,256,180.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.435,317.89v-90.022c-9.257-28.517-27.025-47.824-47.435-47.824 c-51.271,0-92.835,41.564-92.835,92.835s41.564,92.835,92.835,92.835C276.41,365.714,294.178,346.408,303.435,317.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#748993"
    },
    d: "M393.846,272.879c0-15.763-2.652-30.903-7.525-45.011h-49.128v90.022h49.128 C391.194,303.783,393.846,288.642,393.846,272.879z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C4D3D9"
    },
    cx: 343.209,
    cy: 50.637,
    r: 16.879
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C4D3D9"
    },
    cx: 410.725,
    cy: 50.637,
    r: 16.879
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#748993"
    },
    d: "M140.659,42.198H73.143c-4.661,0-8.44-3.778-8.44-8.44s3.779-8.44,8.44-8.44h67.516 c4.661,0,8.44,3.778,8.44,8.44S145.32,42.198,140.659,42.198z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachineColor);
export default __webpack_public_path__ + "static/media/washing_machine_color.37ac4dfcc5e96b9f98144a41e3c62926.svg";
export { ForwardRef as ReactComponent };